import script from "./Response.vue?vue&type=script&setup=true&lang=js"
export * from "./Response.vue?vue&type=script&setup=true&lang=js"

import "./Response.vue?vue&type=style&index=0&id=0c1a5c6a&lang=css"

const __exports__ = script;

export default __exports__